// extracted by mini-css-extract-plugin
export var shortDescriptionWrapper = "footer-sponsor-module--short-description-wrapper--c3dfd";
export var sponsorContainer = "footer-sponsor-module--sponsor-container--12252";
export var sponsorContent = "footer-sponsor-module--sponsor-content--a0c3f";
export var sponsorLogo = "footer-sponsor-module--sponsor-logo--df361";
export var sponsorTitle = "footer-sponsor-module--sponsor-title--13474";